import { render, staticRenderFns } from "./ContactListModal.vue?vue&type=template&id=4d696528&scoped=true&"
import script from "./ContactListModal.vue?vue&type=script&lang=js&"
export * from "./ContactListModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactListModal.vue?vue&type=style&index=0&id=4d696528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d696528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon,VSimpleTable})
